export default {
  API_URI: "https://api.yippity.io",
  // API_URI: "http://localhost:3000",
  MONTHLY_ALLOWANCE: 1,
  PRICE_ID: "price_1PvQKqA8x1JzB9MvY3Hr0rOB",
};
